import * as React from "react";
import Typography from "@material-ui/core/Typography";
import PortfolioFeeSummary from "../../Cy/components/PortfolioFeeSummary";
import Grid from "@material-ui/core/Grid";
import { getValidAdvisorFees } from "../../../utilities/validators";

const PortfolioFeeSummarySection = (props) => {
  const { portfolio, custodians, fees, custodianId, appName, accessLevel } = props;
  const { cprRecommendation, metadata } = portfolio;

  const managerList = cprRecommendation.managers;

  const advisorFee = getValidAdvisorFees(
    portfolio.advisorFee,
    fees.advisorFeeRate,
    fees.advisorDefaultFeeRate,
  );

  return (
    <section className={"content"} data-toc={"Fee Summary"}>
      <Grid container={true} spacing={3} className={"content"}>
        <Grid item={true} xs={12}>
          <Typography variant="h4" gutterBottom>
            Fee Summary
          </Typography>
        </Grid>

        <Grid item={true} xs={6}>
          <PortfolioFeeSummary
            appName={appName}
            managerList={managerList}
            custodians={custodians}
            onboardedCustodianId={portfolio.CustodianId || custodianId}
            portfolioInvestment={metadata.initialInvestment}
            cyPlatformFees={fees.cyPlatformFees}
            userPlatformFees={fees.userPlatformFees}
            userCustodianFees={fees.userCustodianFees}
            portfolioAdvisorFee={advisorFee}
            forPrinting={true}
            accessLevel={accessLevel}
          />
        </Grid>
      </Grid>
    </section>
  );
};

export default PortfolioFeeSummarySection;



// WEBPACK FOOTER //
// ./src/containers/SummaryPDF/components/PortfolioFeeSummarySection.jsx